var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order_logs"},[_vm._l((_vm.logs),function(log){return [_c('order-history-card',{key:log.id,attrs:{"log":log}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }